export const contryNameOptions = [
{ value: 'afghanistan', label: 'Afghanistan' },
{ value: 'albania', label: 'Albania' },
{ value: 'algeria', label: 'Algeria' },
{ value: 'andorra', label: 'Andorra' },
{ value: 'angola', label: 'Angola' },
{ value: 'antigua-&-Deps', label: 'Antigua & Deps' },
{ value: 'argentina', label: 'Argentina' },
{ value: 'armenia', label: 'Armenia' },
{ value: 'australia', label: 'Australia' },
{ value: 'austria', label: 'Austria' },
{ value: 'azerbaijan', label: 'Azerbaijan' },
{ value: 'bahamas', label: 'Bahamas' },
{ value: 'bahrain', label: 'Bahrain' },
{ value: 'bangladesh', label: 'Bangladesh' },
{ value: 'barbados', label: 'Barbados' },
{ value: 'belarus', label: 'Belarus' },
{ value: 'belgium', label: 'Belgium' },
{ value: 'belize', label: 'Belize' },
{ value: 'benin', label: 'Benin' },
{ value: 'bhutan', label: 'Bhutan' },
{ value: 'bolivia', label: 'Bolivia' },
{ value: 'bosnia-Herzegovina', label: 'Bosnia Herzegovina' },
{ value: 'botswana', label: 'Botswana' },
{ value: 'brazil', label: 'Brazil' },
{ value: 'brunei', label: 'Brunei' },
{ value: 'bulgaria', label: 'Bulgaria' },
{ value: 'burkina', label: 'Burkina' },
{ value: 'burundi', label: 'Burundi' },
{ value: 'cambodia', label: 'Cambodia' },
{ value: 'cameroon', label: 'Cameroon' },
{ value: 'canada', label: 'Canada' },
{ value: 'cape-Verde', label: 'Cape Verde' },
{ value: 'central-African-Rep', label: 'Central African Rep' },
{ value: 'chad', label: 'Chad' },
{ value: 'chile', label: 'Chile' },
{ value: 'china', label: 'China' },
{ value: 'colombia', label: 'Colombia' },
{ value: 'comoros', label: 'Comoros' },
{ value: 'congo', label: 'Congo' },
{ value: 'congo-Democratic-Rep', label: 'Congo {Democratic Rep}' },
{ value: 'costa-Rica', label: 'Costa Rica' },
{ value: 'croatia', label: 'Croatia' },
{ value: 'cuba', label: 'Cuba' },
{ value: 'cyprus', label: 'Cyprus' },
{ value: 'czech-Republic', label: 'Czech Republic' },
{ value: 'denmark', label: 'Denmark' },
{ value: 'djibouti', label: 'Djibouti' },
{ value: 'dominica', label: 'Dominica' },
{ value: 'dominican-Republic', label: 'Dominican Republic' },
{ value: 'east-Timor', label: 'East Timor' },
{ value: 'ecuador', label: 'Ecuador' },
{ value: 'egypt', label: 'Egypt' },
{ value: 'el-Salvador', label: 'El Salvador' },
{ value: 'equatorial-Guinea', label: 'Equatorial Guinea' },
{ value: 'eritrea', label: 'Eritrea' },
{ value: 'estonia', label: 'Estonia' },
{ value: 'ethiopia', label: 'Ethiopia' },
{ value: 'fiji', label: 'Fiji' },
{ value: 'finland', label: 'Finland' },
{ value: 'france', label: 'France' },
{ value: 'gabon', label: 'Gabon' },
{ value: 'gambia', label: 'Gambia' },
{ value: 'georgia', label: 'Georgia' },
{ value: 'germany', label: 'Germany' },
{ value: 'ghana', label: 'Ghana' },
{ value: 'greece', label: 'Greece' },
{ value: 'grenada', label: 'Grenada' },
{ value: 'guatemala', label: 'Guatemala' },
{ value: 'guinea', label: 'Guinea' },
{ value: 'guinea-Bissau', label: 'Guinea-Bissau' },
{ value: 'guyana', label: 'Guyana' },
{ value: 'haiti', label: 'Haiti' },
{ value: 'honduras', label: 'Honduras' },
{ value: 'hungary', label: 'Hungary' },
{ value: 'iceland', label: 'Iceland' },
{ value: 'india', label: 'India' },
{ value: 'indonesia', label: 'Indonesia' },
{ value: 'iran', label: 'Iran' },
{ value: 'iraq', label: 'Iraq' },
{ value: 'ireland-Republic', label: 'Ireland {Republic}' },
{ value: 'israel', label: 'Israel' },
{ value: 'italy', label: 'Italy' },
{ value: 'ivory-Coast', label: 'Ivory Coast' },
{ value: 'jamaica', label: 'Jamaica' },
{ value: 'japan', label: 'Japan' },
{ value: 'jordan', label: 'Jordan' },
{ value: 'kazakhstan', label: 'Kazakhstan' },
{ value: 'kenya', label: 'Kenya' },
{ value: 'kiribati', label: 'Kiribati' },
{ value: 'korea-North', label: 'Korea North' },
{ value: 'korea-South', label: 'Korea South' },
{ value: 'kosovo', label: 'Kosovo' },
{ value: 'kuwait', label: 'Kuwait' },
{ value: 'kyrgyzstan', label: 'Kyrgyzstan' },
{ value: 'laos', label: 'Laos' },
{ value: 'latvia', label: 'Latvia' },
{ value: 'lebanon', label: 'Lebanon' },
{ value: 'lesotho', label: 'Lesotho' },
{ value: 'liberia', label: 'Liberia' },
{ value: 'libya', label: 'Libya' },
{ value: 'liechtenstein', label: 'Liechtenstein' },
{ value: 'lithuania', label: 'Lithuania' },
{ value: 'luxembourg', label: 'Luxembourg' },
{ value: 'macedonia', label: 'Macedonia' },
{ value: 'madagascar', label: 'Madagascar' },
{ value: 'malawi', label: 'Malawi' },
{ value: 'malaysia', label: 'Malaysia' },
{ value: 'maldives', label: 'Maldives' },
{ value: 'mali', label: 'Mali' },
{ value: 'malta', label: 'Malta' },
{ value: 'marshall-Islands', label: 'Marshall Islands' },
{ value: 'mauritania', label: 'Mauritania' },
{ value: 'mauritius', label: 'Mauritius' },
{ value: 'mexico', label: 'Mexico' },
{ value: 'micronesia', label: 'Micronesia' },
{ value: 'moldova', label: 'Moldova' },
{ value: 'monaco', label: 'Monaco' },
{ value: 'mongolia', label: 'Mongolia' },
{ value: 'montenegro', label: 'Montenegro' },
{ value: 'morocco', label: 'Morocco' },
{ value: 'mozambique', label: 'Mozambique' },
{ value: 'myanmar-{Burma}', label: 'Myanmar, {Burma}' },
{ value: 'namibia', label: 'Namibia' },
{ value: 'nauru', label: 'Nauru' },
{ value: 'nepal', label: 'Nepal' },
{ value: 'netherlands', label: 'Netherlands' },
{ value: 'new-Zealand', label: 'New Zealand' },
{ value: 'nicaragua', label: 'Nicaragua' },
{ value: 'niger', label: 'Niger' },
{ value: 'nigeria', label: 'Nigeria' },
{ value: 'norway', label: 'Norway' },
{ value: 'oman', label: 'Oman' },
{ value: 'pakistan', label: 'Pakistan' },
{ value: 'palau', label: 'Palau' },
{ value: 'panama', label: 'Panama' },
{ value: 'papua-New-Guinea', label: 'Papua New Guinea' },
{ value: 'paraguay', label: 'Paraguay' },
{ value: 'peru', label: 'Peru' },
{ value: 'philippines', label: 'Philippines' },
{ value: 'poland', label: 'Poland' },
{ value: 'portugal', label: 'Portugal' },
{ value: 'qatar', label: 'Qatar' },
{ value: 'romania', label: 'Romania' },
{ value: 'russian-Federation', label: 'Russian Federation' },
{ value: 'rwanda', label: 'Rwanda' },
{ value: 'st-Kitts & Nevis', label: 'St Kitts & Nevis' },
{ value: 'st-Lucia', label: 'St Lucia' },
{ value: 'saint-Vincent-&-the-Grenadines', label: 'Saint Vincent & the Grenadines' },
{ value: 'samoa', label: 'Samoa' },
{ value: 'san Marino', label: 'San Marino' },
{ value: 'sao-Tome-&-Principe', label: 'Sao Tome & Principe' },
{ value: 'saudi-Arabia', label: 'Saudi Arabia' },
{ value: 'senegal', label: 'Senegal' },
{ value: 'serbia', label: 'Serbia' },
{ value: 'seychelles', label: 'Seychelles' },
{ value: 'sierra-Leone', label: 'Sierra Leone' },
{ value: 'singapore', label: 'Singapore' },
{ value: 'slovakia', label: 'Slovakia' },
{ value: 'slovenia', label: 'Slovenia' },
{ value: 'solomon Islands', label: 'Solomon Islands' },
{ value: 'somalia', label: 'Somalia' },
{ value: 'south-Africa', label: 'South Africa' },
{ value: 'south-Sudan', label: 'South Sudan' },
{ value: 'spain', label: 'Spain' },
{ value: 'sri Lanka', label: 'Sri Lanka' },
{ value: 'sudan', label: 'Sudan' },
{ value: 'suriname', label: 'Suriname' },
{ value: 'swaziland', label: 'Swaziland' },
{ value: 'sweden', label: 'Sweden' },
{ value: 'switzerland', label: 'Switzerland' },
{ value: 'syria', label: 'Syria' },
{ value: 'taiwan', label: 'Taiwan' },
{ value: 'tajikistan', label: 'Tajikistan' },
{ value: 'tanzania', label: 'Tanzania' },
{ value: 'thailand', label: 'Thailand' },
{ value: 'togo', label: 'Togo' },
{ value: 'tonga', label: 'Tonga' },
{ value: 'trinidad & Tobago', label: 'Trinidad & Tobago' },
{ value: 'tunisia', label: 'Tunisia' },
{ value: 'turkey', label: 'Turkey' },
{ value: 'turkmenistan', label: 'Turkmenistan' },
{ value: 'tuvalu', label: 'Tuvalu' },
{ value: 'uganda', label: 'Uganda' },
{ value: 'ukraine', label: 'Ukraine' },
{ value: 'united-Arab-Emirates', label: 'United Arab Emirates' },
{ value: 'united-Kingdom', label: 'United Kingdom' },
{ value: 'united-States', label: 'United States' },
{ value: 'uruguay', label: 'Uruguay' },
{ value: 'uzbekistan', label: 'Uzbekistan' },
{ value: 'vanuatu', label: 'Vanuatu' },
{ value: 'vatican-City', label: 'Vatican City' },
{ value: 'venezuela', label: 'Venezuela' },
{ value: 'vietnam', label: 'Vietnam' },
{ value: 'yemen', label: 'Yemen' },
{ value: 'zambia', label: 'Zambia' },
{ value: 'zimbabwe', label: 'Zimbabwe' },
]